module.exports = __webpack_public_path__ + "img/python-image.6e660a87.svg";